import {createMultiPathSVG} from './TEMPLATE'

// phosphor: caret-down
export const ChevronBottom_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: caret-left
export const ChevronLeft_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: caret-right
export const ChevronRight_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: caret-up-down
export const ChevronTopBottom_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M181.66,170.34a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L128,212.69l42.34-42.35A8,8,0,0,1,181.66,170.34Zm-96-84.68L128,43.31l42.34,42.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,85.66Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: caret-up
export const ChevronTop_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: caret-down
export const TinyChevronBottom_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z',
  ],
  viewBox: '-68.923 -68.923 393.846 393.846',
})
